export const BIBLE_GETTER_BOOKS_EXHIBITION_TYPE = 'bible/getter/booksExhibitionType';
export const BIBLE_GETTER_BOOKS_SHOW_PINIYN = 'bible/getter/booksShowPinyin';
export const BIBLE_GETTER_VERSES_SHOW_AS_MODAL = 'bible/getter/versesShowAsModal';
export const BIBLE_GETTER_VERSES_MODAL_VISIBLE = 'bible/getter/versesModalVisible';
export const BIBLE_GETTER_OPEN_CHAPTER_ON_LOAD = 'bible/getter/openChapterOnLoad';

export const BIBLE_MUTATION_SET_BOOKS_EXHIBITION_TYPE = 'bible/mutation/SET_BOOKS_EXHIBITION_TYPE';
export const BIBLE_MUTATION_SET_BOOKS_SHOW_PINYIN = 'bible/mutation/SET_BOOKS_SHOW_PINYIN';
export const BIBLE_MUTATION_SET_VERSES_SHOW_AS_MODAL = 'bible/mutation/SET_VERSES_SHOW_AS_MODAL';
export const BIBLE_MUTATION_SET_VERSES_MODAL_VISIBLE = 'bible/mutation/SET_VERSES_MODAL_VISIBLE';
export const BIBLE_MUTATION_SET_OPEN_CHAPTER_ON_LOAD = 'bible/mutation/OPEN_CHAPTER_ON_LOAD';
